export const ADMIN_TYPE = {
	SUPER_ADMIN: 'superadmin'
}
